module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/entities/devices/device-detail/climatization-detail/climatization-detail.component.scss
// module id = ./src/app/entities/devices/device-detail/climatization-detail/climatization-detail.component.scss
// module chunks = main